"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var api = __importStar(require("./api"));
var components_1 = require("./components");
var utils_1 = require("./utils");
var constants_1 = require("../../constants");
var interfaces_1 = require("./interfaces");
var TradeIn = /** @class */ (function (_super) {
    __extends(TradeIn, _super);
    function TradeIn(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.getDefaultState();
        _this.restart = _this.restart.bind(_this);
        _this.initialRequest = _this.initialRequest.bind(_this);
        _this.__initialRequest = _this.__initialRequest.bind(_this);
        _this.calculate = _this.calculate.bind(_this);
        _this.changeMileageDirectly = _this.changeMileageDirectly.bind(_this);
        _this.removeTradeIn = _this.removeTradeIn.bind(_this);
        _this.afterModificationChange = _this.afterModificationChange.bind(_this);
        _this.setAmount = _this.setAmount.bind(_this);
        _this.toggleBrandHandler = _this.toggleBrandHandler.bind(_this);
        _this.loadingStruct = _this.buildLoadingStruct();
        return _this;
    }
    TradeIn.prototype.setAmount = function (amount) {
        var _this = this;
        if (amount > 10000000) {
            return;
        }
        this.setState({
            amount: amount,
        }, function () {
            var error = _this.state.haveError || _this.state.noCalculations;
            _this.props.onChange(_this.generateOnChangeObject(amount, error));
        });
    };
    TradeIn.prototype.getDefaultState = function (state) {
        return __assign({ model: undefined, year: undefined, body: undefined, modification: undefined, generation: undefined, brand: undefined, equipment: undefined, mileage: 0, owner: utils_1.getAvailableOwners()[0].id, amount: 0, noCalculations: false, haveError: false, options: {
                model: [],
                brand: [],
                generation: [],
                year: [],
                modification: [],
                equipment: [],
                body: [],
                owner: utils_1.getAvailableOwners(),
                mileage: utils_1.getAvailableMileage(),
            }, loading: {}, visible: {
                brand: false,
                model: false,
                generation: false,
                year: false,
                modification: false,
                owners: false,
                mileage: false,
            }, opened: {
                brand: true,
            } }, state);
    };
    TradeIn.prototype.toggleOpened = function (field) {
        var opened = utils_1.clone(this.state.opened);
        opened[field] = !opened[field];
        this.setState({
            opened: opened,
        });
    };
    TradeIn.prototype.buildLoadingFunction = function (_a) {
        var _this = this;
        var field = _a.field, func = _a.func, cb = _a.cb;
        return function () {
            var _a;
            _this.setState({
                loading: (_a = {}, _a[field] = true, _a),
            }, function () { return __awaiter(_this, void 0, void 0, function () {
                var result, options, isSingle;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, func(this.state)];
                        case 1:
                            result = _a.sent();
                            options = utils_1.clone(this.state.options);
                            options[field] = utils_1.clone(result.objects).filter(function (option) { return !!option.id; });
                            isSingle = result.objects.length === 1;
                            // Сюда добавить определение что скрывать, открывать и показывать
                            this.setState({
                                haveError: !result.ok,
                                loading: {},
                                options: options,
                            }, isSingle ? function () {
                                _this.change({ key: field, value: result.objects[0].id.toString() });
                                //cb ? cb() : undefined;
                            } : cb);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
    };
    TradeIn.prototype.buildLoadingStruct = function () {
        return {
            brand: this.buildLoadingFunction({
                field: 'model',
                func: api.getModels,
                cb: this.removeTradeIn,
            }),
            model: this.buildLoadingFunction({
                field: 'generation',
                func: api.getGenerations,
                cb: this.removeTradeIn,
            }),
            generation: this.buildLoadingFunction({
                field: 'year',
                func: api.getYears,
                cb: this.removeTradeIn,
            }),
            year: this.buildLoadingFunction({
                field: 'body',
                func: api.getBodies,
                cb: this.removeTradeIn,
            }),
            body: this.buildLoadingFunction({
                field: 'modification',
                func: api.getModifications,
                cb: this.removeTradeIn,
            }),
            modification: this.afterModificationChange,
            mileage: this.calculate,
            owner: this.calculate,
        };
    };
    TradeIn.prototype.afterModificationChange = function () {
        var opened = __assign({}, this.state.opened);
        opened.mileage = true;
        opened.owner = true;
        this.setState({
            opened: opened,
        }, this.calculate);
    };
    TradeIn.prototype.getLoadingFunc = function (field) {
        return this.loadingStruct[field];
    };
    TradeIn.prototype.changeMileageDirectly = function (value, cb) {
        this.setState({
            mileage: value || undefined,
        }, cb);
    };
    TradeIn.prototype.generateOnChangeObject = function (cost, error) {
        var _a = this.state, modification = _a.modification, brand = _a.brand, mileage = _a.mileage, year = _a.year, model = _a.model;
        var onChangeObject = {
            amount: cost,
            error: error,
        };
        if (!!mileage) {
            onChangeObject.mileage = mileage;
        }
        if (!!year) {
            onChangeObject.year = year;
        }
        if (!!modification) {
            var object = this.state.options.modification.filter(function (o) { return o.id === modification; })[0];
            if (!!object) {
                onChangeObject.modification = object;
            }
        }
        if (!!brand) {
            var object = this.state.options.brand.filter(function (o) { return o.id === brand; })[0];
            if (!!object) {
                onChangeObject.brand = object;
            }
        }
        if (!!model) {
            var object = this.state.options.model.filter(function (o) { return o.id === model; })[0];
            if (!!object) {
                onChangeObject.model = object;
            }
        }
        return onChangeObject;
    };
    TradeIn.prototype.removeTradeIn = function () {
        var error = this.state.haveError || this.state.noCalculations;
        this.props.onChange(this.generateOnChangeObject(0, error));
    };
    TradeIn.prototype.calculate = function () {
        var _this = this;
        var _a = this.state, modification = _a.modification, brand = _a.brand, equipment = _a.equipment, body = _a.body, mileage = _a.mileage, year = _a.year, generation = _a.generation, model = _a.model, owner = _a.owner;
        if (this.isLoading() || !modification) {
            return;
        }
        this.setState({
            loading: { calculations: true },
        }, function () { return __awaiter(_this, void 0, void 0, function () {
            var result, onChangeObject;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.predictCost({
                            modification: modification, body: body, equipment: equipment, brand: brand,
                            mileage: mileage || 0,
                            year: year, generation: generation, model: model,
                            owners: owner,
                        })];
                    case 1:
                        result = _a.sent();
                        onChangeObject = this.generateOnChangeObject(result.ok ? result.cost : 0, !result.ok);
                        this.setState({
                            loading: { calculations: false },
                            amount: result.cost,
                            haveError: !result.ok,
                            noCalculations: !result.ok,
                        }, function () {
                            _this.props.onChange(onChangeObject);
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    TradeIn.prototype.__initialRequest = function () {
        return __awaiter(this, void 0, void 0, function () {
            var brandsResult, options;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.getBrands()];
                    case 1:
                        brandsResult = _a.sent();
                        options = utils_1.clone(this.state.options);
                        options.brand = utils_1.clone(brandsResult.objects);
                        this.setState({
                            loading: { brand: false },
                            haveError: !brandsResult.ok,
                            options: options,
                        }, function () {
                            _this.removeTradeIn();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TradeIn.prototype.initialRequest = function () {
        this.setState({
            haveError: false,
            noCalculations: false,
            loading: { brand: true },
        }, this.__initialRequest);
    };
    TradeIn.prototype.restart = function () {
        this.setState(this.getDefaultState(), this.initialRequest);
    };
    TradeIn.prototype.restartOtherBrand = function () {
        // при рестарте открываем выбор марки
        var state = {
            visible: {
                brand: true,
                model: false,
                generation: false,
                year: false,
                modification: false,
                owners: false,
                mileage: false,
            },
        };
        this.setState(this.getDefaultState(state), this.initialRequest);
    };
    TradeIn.prototype.isLoading = function () {
        return Object.values(this.state.loading).some(function (v) { return !!v; });
    };
    TradeIn.prototype.componentDidMount = function () {
        api.setApiUri(this.props.domain);
        this.initialRequest();
    };
    TradeIn.prototype.change = function (_a) {
        var key = _a.key, value = _a.value, visible = _a.visible;
        var fieldsToClear = utils_1.getFieldsToClear(key);
        var state = utils_1.clone(this.state);
        state.opened[key] = false;
        state.visible[key] = visible !== null && visible !== void 0 ? visible : state.visible[key];
        state[key] = value;
        state.amount = 0;
        for (var fieldIndex = 0; fieldIndex < fieldsToClear.length; fieldIndex++) {
            var field = fieldsToClear[fieldIndex];
            state[field] = '';
            state.options[field] = [];
            /**
             * Если индекс равен 0 - это следующее поле. Его нужно сделать видимым и открыть
             * Если всё остальное сделать невидимым и закрыть
             */
            if (fieldIndex === 0) {
                state.visible[field] = true;
                state.opened[field] = true;
            }
            else {
                state.visible[field] = false;
                state.opened[field] = false;
            }
        }
        this.setState(state, this.getLoadingFunc(key));
    };
    TradeIn.prototype.toggleBrandHandler = function (value) {
        if (value === interfaces_1.VehicleBrands.suzuki) {
            return this.change({ key: 'brand', value: value, visible: false });
        }
        return this.restartOtherBrand();
    };
    TradeIn.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.state, brand = _b.brand, model = _b.model, generation = _b.generation, year = _b.year, body = _b.body, modification = _b.modification, owner = _b.owner, options = _b.options, loading = _b.loading, amount = _b.amount, haveError = _b.haveError, noCalculations = _b.noCalculations, mileage = _b.mileage, visible = _b.visible, opened = _b.opened;
        var tradeInDiscounts = this.props.tradeInDiscounts;
        if (haveError) {
            return (React.createElement(components_1.Error, { amount: amount, setAmount: this.setAmount, noCalculations: noCalculations, restart: this.restart }));
        }
        var isLoading = Object.values(loading).some(function (v) { return !!v; });
        var brands = tradeInDiscounts ? Object.keys(tradeInDiscounts).map(function (key) { return ({
            value: key,
            title: constants_1.TRADE_IN_TITLES[key],
            price: tradeInDiscounts[key].discount,
        }); }) : undefined;
        var hiddenToggleBrand = !!brands && brands.every(function (brand) { return !brand.price; });
        var defaultBrand = hiddenToggleBrand || !brand
            ? undefined
            : brand === interfaces_1.VehicleBrands.suzuki
                ? interfaces_1.VehicleBrands.suzuki
                : interfaces_1.VehicleBrands.other;
        var searchableSelectOptions = (hiddenToggleBrand
            ? options.brand
            : options.brand.filter(function (_a) {
                var id = _a.id;
                return id !== interfaces_1.VehicleBrands.suzuki;
            }));
        return (React.createElement("div", { className: classnames_1.default("tradein-estimate", (_a = {},
                _a["tradein-estimate--border"] = !hiddenToggleBrand,
                _a["tradein-estimate--border-only-top"] = hiddenToggleBrand,
                _a)) },
            isLoading ? (React.createElement("div", { className: "tradein-preloader" })) : null,
            React.createElement("div", { className: "tradein-estimate__collapse" },
                !hiddenToggleBrand && (React.createElement(components_1.ToggleBrand, { defaultBrand: defaultBrand, brands: brands, onChangeBrand: this.toggleBrandHandler })),
                React.createElement(components_1.SearchableSelect, { isVisible: visible.brand || hiddenToggleBrand, value: brand, isOpened: opened.brand, suzukiFirst: hiddenToggleBrand, toggle: function () { return _this.toggleOpened('brand'); }, label: '\u041C\u0430\u0440\u043A\u0430', options: searchableSelectOptions, canBeOpened: Array.isArray(options.brand) && options.brand.length > 0, onChange: function (val) { return _this.change({ key: 'brand', value: val, }); } }),
                React.createElement(components_1.Select, { value: model, isOpened: opened.model, withPopular: true, toggle: function () { return _this.toggleOpened('model'); }, canBeOpened: !!brand, isVisible: visible.model, label: '\u041C\u043E\u0434\u0435\u043B\u044C', options: options.model, onChange: function (val) { return _this.change({ key: 'model', value: val, }); } }),
                React.createElement(components_1.Select, { value: generation, isOpened: opened.generation, toggle: function () { return _this.toggleOpened('generation'); }, canBeOpened: !!model, isVisible: visible.generation, label: '\u041F\u043E\u043A\u043E\u043B\u0435\u043D\u0438\u0435', options: options.generation, onChange: function (val) { return _this.change({ key: 'generation', value: val, }); } }),
                React.createElement(components_1.Select, { value: year, isOpened: opened.year, toggle: function () { return _this.toggleOpened('year'); }, canBeOpened: !!generation, isVisible: visible.year, label: '\u0413\u043E\u0434 \u0432\u044B\u043F\u0443\u0441\u043A\u0430', options: options.year, onChange: function (val) { return _this.change({ key: 'year', value: val, }); } }),
                React.createElement(components_1.Select, { value: body, isOpened: opened.body, toggle: function () { return _this.toggleOpened('body'); }, canBeOpened: !!year, isVisible: visible.body, label: '\u0422\u0438\u043F \u043A\u0443\u0437\u043E\u0432\u0430', options: options.body, onChange: function (val) { return _this.change({ key: 'body', value: val, }); } }),
                React.createElement(components_1.Select, { value: modification, isOpened: opened.modification, toggle: function () { return _this.toggleOpened('modification'); }, canBeOpened: !!body, isVisible: !!body, label: '\u041C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F', options: options.modification, onChange: function (val) { return _this.change({ key: 'modification', value: val, }); } }),
                React.createElement(components_1.Select, { value: owner, isOpened: opened.owner, toggle: function () { return _this.toggleOpened('owner'); }, canBeOpened: true, isVisible: !!modification, label: '\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432 \u043F\u043E \u041F\u0422\u0421', options: options.owner, onChange: function (val) { return _this.change({ key: 'owner', value: val, }); } }),
                React.createElement(components_1.Mileage, { isVisible: !!modification, isOpened: opened.mileage, toggle: function () { return _this.toggleOpened('mileage'); }, value: mileage, calculate: this.calculate, change: this.changeMileageDirectly })),
            React.createElement(components_1.Price, { amount: amount }),
            React.createElement(components_1.Agreement, { isVisible: !!brand || visible.brand, amount: amount })));
    };
    return TradeIn;
}(React.PureComponent));
exports.default = TradeIn;
